import { useCallback, useState } from 'react';

export function useFilters<T extends Record<string, unknown>>(defaults: T) {
  const [filters, setFilters] = useState<T>(defaults);

  const setFilter = useCallback((filterName: string, value: unknown) => {
    setFilters((current) => ({
      ...current,
      [filterName]: value
    }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters({ ...defaults });
  }, [defaults]);

  return {
    filters,
    resetFilters,
    setFilter
  };
}
